<script>
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
import { toArrayBuffer, formatDate, lkKey } from "src/utils";
import Grid from "../Shared/Grid";
const moment = require("moment");

export default {
  name: "ClassPayments",
  components: {
    Grid
  },
  data() {
    return {
      moment: moment,      
      module: this.$route.meta.module,
      rowsPerPageOptions: [],
      columnOptions: [
        {
          field: "ORDER_ID",
          name: "ORDER_ID",
          label: "Order ID",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          width: "90px"
        },
        {
          field: "DATE_CREATED",
          name: "DATE_CREATED",
          label: "Order Date",
          sortable: true,
          filterable: false,
          type: "date",
          align: "left",
          format: value => {
            return this.formattedDate(value);
           
          }
        },
        {
          field: "LK_ORDER_STATUS",
          name: "STATUS",
          label: "Status",
          sortable: true,
          filterable: true,
          type: "string",
          align: "left",
          format: value => {
            return value ? `${lkKey("LK_ORDER_STATUS_ID", value)}` : null;
          }
        },
        {
          field: "USER",
          align: "left",
          name: "USER",
          label: "Placed By",
          sortable: true,
          filterable: true,
          type: "string"
        },
        {
          field: "TOTAL",
          name: "TOTAL",
          label: "Total",
          sortable: true,
          filterable: false,
          type: "number",
          format: value => {
            return value != undefined ? `$${parseFloat(value).toFixed(2)}` : "";
          }
        }
      ]
    };
  },
  mounted(){
    let vm = this
  },
  computed: {
    ...mapState({
      orders: s => s.classes.sessionInformation.orders,
      loadingCertificates: s => s.classes.loadingCertificates,
      class: s => s.classes.sessionInformation,
    }),
  },
  methods: {
    ...mapActions('orders', ['one']),
    formatUserInitials(user) {
      return user.USER_FIRST_NAME[0] + user.USER_LAST_NAME[0];
    },
    formattedDate(dateString) {
      var finalDateString;
      var d = new Date(dateString);
      var mm = d.getMonth() + 1;
      var dd = d.getDate();
      var yy = d.getFullYear();
      var hh = d.getHours();
      var hours = d.getHours();
      var ampm = hours >= 12 ? 'pm' : 'am';
      var minutes = d.getMinutes();
      var seconds = d.getSeconds();
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
     
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (dd < 10) {
        dd = "0" + dd;
      }
      
      var strTime = hours + ":" + minutes + " " + ampm;
      finalDateString = mm + "/" + dd + "/" + yy+" "+strTime;

      return finalDateString;
    }
  }
};
</script>

<template>
  <div class="fit">
    <Grid
      id="certificatesListGrid"
      :module="module"
      :data="orders"
      :rows-per-page-options="[0]"
      :columns="columnOptions"
      :onLaunch="one"
    >
      <template slot="col-item-status" slot-scope="props">
        <div
          style="display:inline-block;margin-left: 10px;border-radius:30px"
          class="label"
          :class="{
                  'blue': props.value == 'Placed',
                  'green' : props.value =='Completed' || props.value =='Fulfilled',
                  'red' : props.value =='Cancelled'
              }"
        >{{props.value || '?'}}</div>
      </template>
      <template slot="col-item-user" slot-scope="props">
        <div
          class="label green round small"
          style="font-size: 11px;padding: 6px 0px;margin-right: 5px"
        >{{formatUserInitials(props.value)}}</div>
        {{props.value.USER_FIRST_NAME}} {{props.value.USER_LAST_NAME}}
      </template>
    </Grid>
  </div>
</template>

<style>
</style>